import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { toast } from "react-toastify";
import qs from "query-string";

import { captureMessage } from "clients/helpers/logger";
import { Severity } from "@sentry/types";

import { PASSWORD_WAS_SET } from "shared/helpers/messages";
import { Path } from "../../../store/path/constants";
import {
  ExpiredPasswordResetCode,
  forgotPasswordSubmit,
  IAuthChangePassword,
} from "shared/store/auth/api";

import PasswordChangeForm from "shared/components/forms/auth/resetPassword/PasswordChangeForm";

const ConfirmResetPassword = ({ location, history }: RouteComponentProps) => {
  useEffect(() => {
    const query: any = qs.parse(location.search);
    if (!query.user_name || !query.confirmation_code) {
      toast.error("Something went wrong, please try again.");
      captureMessage("Confirmation link malformed", {
        extra: { query },
        level: Severity.Error,
      });
      history.push(Path.LOGIN);
    }
  }, [location, history]);

  const changePassword = async (data: IAuthChangePassword) => {
    try {
      const query: any = qs.parse(location.search);
      await forgotPasswordSubmit({
        password: data.password,
        confirmation_code: query.confirmation_code,
        user_name: query.user_name.replace(" ", "+"),
      });
      toast.success(PASSWORD_WAS_SET);
      history.push(Path.LOGIN);
      return;
    } catch (e) {
      if (e instanceof ExpiredPasswordResetCode) {
        toast.warn(e.message);
        history.push(Path.RESET_PASSWORD);
      } else {
        toast.error(e.message);
        captureMessage(e.message, {
          extra: { query: location.search },
          level: Severity.Error,
        });
        history.push(Path.LOGIN);
      }
      return;
    }
  };

  return (
    <div className="app-body center login-page">
      <div className="component-box with-header">
        <div className="component-box-header">
          <h1 className="font-regular">Enter new password</h1>
        </div>
        <PasswordChangeForm changePassword={changePassword} />
      </div>
    </div>
  );
};

export default ConfirmResetPassword;
